import { Component, ViewChild } from "@angular/core";
import {
  NavController,
  NavParams,
  Refresher,
  VirtualScroll,
  Content,
  AlertController,
} from "ionic-angular";
import * as Enumerable from "linq";
import * as moment from "moment";
import { NavEntity } from "../../models";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { DemoProvider } from "../../providers/demo/demo";
import { StarmsClientProvider } from "../../providers/starms-client/starms-client";
import { TimeProvider } from "../../providers/time/time";
import { Report, ReportAdapter } from "../../app/models/Reports";

@Component({
  selector: "page-reports",
  templateUrl: "reports.html",
})
export class ReportsPage {
  nav: NavEntity;
  reports: Array<any> = [];
  selectedReports: Array<any> = [];
  filter: any = "all";
  availableData = true;
  years: number[] = [];
  visibility: any;
  loadingData = true;
  refresher: Refresher;
  visibilities = new Map<number, boolean>();
  @ViewChild("contentr") content: Content;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public global: DemoProvider,
    private inAppBrowser: InAppBrowser,
    private starms: StarmsClientProvider,
    private time: TimeProvider,
    private alertCtrl: AlertController
  ) {}

  async presentAlert(element: any) {
    let alert = this.alertCtrl.create({
      title: element.title,
      message: element.message,
      buttons: [
        {
          text: "Do not show again",
          role: "cancel",
          handler: () => {
            this.visibilities[element.id] = false;
            localStorage.setItem(
              "visibilities",
              JSON.stringify(this.visibilities)
            );
          },
        },
        {
          text: "Dismiss",
          role: "dismiss",
          handler: () => {},
        },
      ],
    });
    await alert.present();
  }

  ionViewDidLoad() {
    this.nav = this.navParams.data;
    this.getData();
  }

  ionViewDidEnter() {}

  getData() {
    let timeParams = this.time.getTimeParams(1460);
    this.starms
      .get(["documents", this.nav.getType() + "s", this.nav.getId()], {
        from: timeParams.from,
        to: this.time.add(timeParams.to, 1, "d"),
      })
      .map((reports) =>
        reports.map((report) => new ReportAdapter().adapt(report))
      )
      .subscribe(
        (reports) => {
          this.reports = Enumerable.from(reports)
            .orderByDescending((x) => x["date"])
            .toArray();
          this.getYears();
          this.selectedReports = this.reports;
          this.checkDataAvailable();
        },
        (error) => {
          this.availableData = false;
        }
      )
      .add(() => {
        this.loadingData = false;
        if (this.refresher) {
          this.refresher.complete();
        }
      });
  }

  checkDataAvailable(): void {
    if (this.reports.length) {
      this.availableData = true;
    } else {
      this.availableData = false;
    }
  }

  getYears(): void {
    this.years = Enumerable.from(this.reports)
      .select(function (x) {
        return moment(x["date"]).get("year");
      })
      .distinct()
      .toArray();
  }

  download(report: Report): void {
    if (this.global.demoMode) {
      this.inAppBrowser.create(
        "https://sta-rms.siemens-energy.com/myhealth/assets/redirect.html?redirect=" +
          "myhealth/assets/demo-data/" +
          report.title,
        "_system",
        "location=yes"
      );
    } else {
      this.inAppBrowser.create(
        `https://sta-rms.siemens-energy.com/myhealth/assets/redirect.html?redirect=${report.downloadPath}`,
        // report.getDownloadUrl().substring(1, report.getDownloadUrl().length),
        "_system",
        "location=yes"
      );
    }
  }

  changeDateViewTimeRange(filter: string) {
    this.filter = filter;
    this.selectedReports = [];
    if (this.filter !== "all") {
      this.selectedReports = this.reports.filter(
        (x) => moment(x["date"]).get("year") === this.filter
      );
    } else {
      this.selectedReports = this.reports;
    }
    this.content.scrollToTop();
  }

  refresh(refresher: Refresher) {
    this.refresher = refresher;
    this.getData();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts